import { Color } from '../../color.model';

export const sky: Color = {
  light: {
    0: 'hsl(0, 0%, 0%)',
    1: 'hsl(193, 100%, 98.8%)',
    2: 'hsl(193, 100%, 97.3%)',
    3: 'hsl(193, 99%, 94.7%)',
    4: 'hsl(193, 91.4%, 91.4%)',
    5: 'hsl(194, 82%, 86.6%)',
    6: 'hsl(194, 74.1%, 79.5%)',
    7: 'hsl(194, 72.3%, 69.6%)',
    8: 'hsl(193, 77.9%, 53.9%)',
    9: 'hsl(193, 98%, 70%)',
    10: 'hsl(193, 87%, 66.5%)',
    11: 'hsl(195, 100%, 31.5%)',
    12: 'hsl(195, 100%, 13%)',
  },
  dark: {
    0: 'hsl(0, 0%, 0%)',
    1: 'hsl(205, 45%, 8.6%)',
    2: 'hsl(202, 71.4%, 9.6%)',
    3: 'hsl(201, 74.6%, 12.2%)',
    4: 'hsl(201, 77.4%, 14.4%)',
    5: 'hsl(200, 80.3%, 16.5%)',
    6: 'hsl(200, 84.1%, 18.9%)',
    7: 'hsl(199, 90.2%, 22.1%)',
    8: 'hsl(198, 100%, 26.1%)',
    9: 'hsl(193, 98%, 70%)',
    10: 'hsl(192, 100%, 77%)',
    11: 'hsl(192, 85%, 55.8%)',
    12: 'hsl(198, 98%, 95.8%)',
  },
};
